import React, { useEffect } from 'react';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import { PaginationItem } from '@mui/material';
import ArrowBack from '@mui/icons-material/ArrowBack';
import ArrowForward from '@mui/icons-material/ArrowForward';
import { styled } from '@mui/material/styles';

const PaginationDev = styled(Pagination)(({ theme }) => ({

  '& .MuiPagination-ul': {
    justifyContent: "center",
    flexWrap: "nowrap",
  },
  '& .MuiButtonBase-root': {
    borderRadius: "9px"
  },
  '& .Mui-selected:hover': {
    backgroundColor: "#ff6614",
    color: "#ffffff"
},
  '& .Mui-selected': {
    backgroundColor: "#ff6614!important",
    color: "#ffffff"
}

}));


function getUrlFiltrPagination (checked) {
  let filter = "";
  for (var key in checked) {
    checked[key].map(u => {
              filter += `filter[${key}][]=${u}&`;
    })
  }

  return filter;
}

function PaginationCatologMoby(props) {
  
    let countPages= Math.ceil(props.countItems/props.pageSize);
    const [page, setPage] = React.useState(props.currentPage);
    useEffect(() => {
      setPage(props.currentPage);
    },[props.currentPage]);

    const handleChange = (event, value) => {
      setPage(value);

      let filter='';
      props.paramsQuerry.paramsQuerry.map((getpar, ii) => {
        let filtr = getpar[0].split(/^(.+)+\[(.+)+\](.+)+/gm)[1];
        let filtrSort = getpar[0];
        let filtrSortValue = getpar[1];
        let filtrGetParamsKey = getpar[0].split(/^(.+)+\[(.+)+\](.+)+/gm)[2];
        let filtrGetParamsValue = Number(getpar[1]);
  
        if (filtrSort === "tag") {
  
          filter +=`${filtrSort}=${filtrSortValue}&`;
        }
      });
      for (var key in props.checked) {
        props.checked[key].map(u => {
          filter += `filter[${key}][]=${u}&`;
        })
      }
      let valueSelected=props.valueSelected;
      props.setCurrentPage(value);
  
      props.getCatalogItems(props.pageSize, value,  "&" + filter + valueSelected );
      window.location.href = `/${props.catalogUrl}/?` + filter + "page="+value+"&countItems="+props.pageSize + "&" + valueSelected;
      window.scrollTo(0, 0);
    };
    return (
      <>
      {countPages > 1 && (
      <Stack spacing={3} sx={{mb:8}}>
        <PaginationDev 
        count={countPages} 
        variant="outlined" 
        shape="rounded"   
        page={page} 
        onChange={handleChange}
         sx={{mb:8}}
         renderItem={(item) => (
          <PaginationItem sx={{ height: "32px", minWidth: "7.7vw"}}
            components={{ previous: ArrowBack, next: ArrowForward }}
            {...item}
          />             )}
         />
      </Stack>
      )}
      </>
    );
  }


  export default PaginationCatologMoby;